import React, { useEffect } from "react";
import {
  useHistory,
  useLocation
} from "react-router-dom/cjs/react-router-dom.min";
import Error from "share/organisms/error";
import styled from "styled-components";
import { useQuery } from "share/atoms/use-query";
const Wrapper = styled.div`
  background-color: #ffff;
  width: 60%;
  margin: 70px auto;
  padding: 30px 0;
`;
const ErrorPage = () => {
  const history = useHistory();
  const location = useLocation();
  const query = useQuery();
  const { message, statusCode, errors } = location.state || {};

  console.log(message, statusCode);

  console.log("a.a.a.locaion", location, query.get("message"));

  useEffect(() => {
    if (location && query.get("message") === "Session expired") {
      return true;
    } else if (location && query.get("message") === "internal_error") {
      return true;
    } else if (message === undefined) {
      history.push({ pathname: "/" });
    }
  }, [message || "Session Expired"]);
  if (location && query.get("message") === "internal_error") {
    return <Error error={{ message: "500" }} />;
  }
  return (
    <>
      <Error
        title="Multiple Devices Found"
        desc="Your account has been accessed from a new device. As a result, you have been logged out of this device."
        error={errors || { message: "Session expired" }}
      />
    </>
  );
};

export default ErrorPage;
